import {
  DisplayFormulario,
  TipoCampoFormulario,
} from 'src/app/compartido/formulario/utilidades/formulario.models';
import { OPCIONES_CIUDADES_FORMULARIO, OPCIONES_DEPARTAMENTOS_FORMULARIO } from 'src/app/compartido/formulario/utilidades/formulario.static';

import { ConfiguracionFormulario } from 'src/app/compartido/formulario/utilidades/formulario.models';

/* Configuración del formulario de dirección */
export const CONFIGURACION_FORMULARIO_DIRECCION: ConfiguracionFormulario = {
  campos: [
    {
      nombre: 'ID',
      slug: 'id',
      tipo: TipoCampoFormulario.NUMERO,
      readonly: true,
    },
    {
      nombre: 'Dirección Original',
      slug: 'direccion',
      tipo: TipoCampoFormulario.AUTOCOMPLETE,
      opciones: [], // Se obtiene del servidor
      readonly: true,
    },
    {
      nombre: 'Dirección Formateada',
      slug: 'direccion_formateada',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Detalles',
      slug: 'detalles',
      tipo: TipoCampoFormulario.TEXTO,
      placeholder: 'Apartamento, casa, torre, etc.',
    },
    {
      nombre: 'Barrio',
      slug: 'barrio',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Localidad',
      slug: 'localidad',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Ciudad',
      slug: 'ciudad',
      tipo: TipoCampoFormulario.AUTOCOMPLETE,
      opciones: OPCIONES_CIUDADES_FORMULARIO,
      requerido: true,
      soloOpcion: true,
      filtrarOpciones: true,
    },
    {
      nombre: 'Departamento',
      slug: 'departamento',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: OPCIONES_DEPARTAMENTOS_FORMULARIO,
      requerido: true,
    },
    // {
    //   nombre: 'Latitud',
    //   slug: 'latitud',
    //   tipo: TipoCampoFormulario.NUMERO,
    //   decimal: true,
    //   roles: [RolUsuario.ELEVA],
    // },
    // {
    //   nombre: 'Longitud',
    //   slug: 'longitud',
    //   tipo: TipoCampoFormulario.NUMERO,
    //   decimal: true,
    //   roles: [RolUsuario.ELEVA],
    // },
    // {
    //   nombre: 'Coordenadas',
    //   slug: 'coordenadas',
    //   tipo: TipoCampoFormulario.COORDENADAS,
    //   placeholder: 'Seleccione una ubicación',
    //   roles: [RolUsuario.ELEVA],
    // },
    // {
    //   nombre: 'Creación manual',
    //   slug: 'creacion_manual',
    //   tipo: TipoCampoFormulario.BOOLEANO,
    //   placeholder: 'Sí',
    // },
  ],
  estilo: {
    display: DisplayFormulario.GRID,
  },
};
